import { PUBLIC_POCKETBASE_URL } from '$env/static/public';
import PocketBase, { type AuthModel } from 'pocketbase';
import { writable } from 'svelte/store';

/**
 * Create a new PocketBase instance.
 */
export const createClient = (url: string) => {
  const pb = new PocketBase(url);
  pb.autoCancellation(false);
  return pb;
};

/**
 * Client PocketBase instance for client-side requests.
 */
export const pbClient = createClient(PUBLIC_POCKETBASE_URL);

export const currentUser = writable<AuthModel | null>();
